import { render, staticRenderFns } from "./TabInsurance.vue?vue&type=template&id=2728bd3a&scoped=true&"
import script from "./TabInsurance.vue?vue&type=script&lang=js&"
export * from "./TabInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728bd3a",
  null
  
)

export default component.exports